import { themeTh } from '@rbilabs/components-library';

export { themeTh as theme };
